// extracted by mini-css-extract-plugin
export default {"title":"xO1Hw","buttonTabsWrapper":"fmN9G","bankBanner":"IxcTB","cardInfo":"cpN3d"};